import React, { CSSProperties } from "react";

type Props = {
  style?: CSSProperties;
  icon: string;
  text?: string;
  text2?: string;
  testID?: string;
};

export const ListItemAssetLarge = (props: Props) => {
  if (props.text2){
    return (
      <div
        style={{
          paddingLeft: 4,
          paddingRight: 4,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <img src={props.icon} />
        <div style={styles.text}>{props.text}<br/>{props.text2}
        </div>
      
      </div>
    );
  }
  return (
    <div
      style={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <img src={props.icon} />
      <div style={styles.text}>{props.text}
      </div>
    
    </div>
  );
};

const styles = {
  container: {
    paddingLeft: 4,
    paddingRight: 4,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    marginLeft: 16,

    fontSize: 16,
    color: "#FFFFFF",
  },
};



// WEBPACK FOOTER //
// ./src/components/ListItemAssetLarge.tsx